import React from 'react';
import { translate } from '../../../services/translate';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { DebuggerSubTag } from './Debugger';

interface Props {
    items: DebuggerSubTag[];
    value: DebuggerSubTag[];
    setValue: React.Dispatch<React.SetStateAction<DebuggerSubTag[]>>;
    zIndex: number;
    single?: boolean;
}

export default function DebuggerSubTagsDropdown({ value, setValue, zIndex, items }: Props) {

    return (
        <FilterDropdown
            label={translate('tag')}
            items={items.map(item => {
                return { label: translate(item), value: item };
            })}
            multiple={true}
            mode='BADGE'
            setValue={setValue}
            disabled={items.length === 0}
            onChangeValue={(values) => {
                if (values && values.length > 1) {
                    setValue(values as DebuggerSubTag[]);
                }
            }}
            value={value}
            zIndex={zIndex}
        />
    );
}
